import React from "react";
import { PrivacyPolicy } from "../../components/Navigation/Privacy/PrivacyPolicy";
import "../legal/style.css";

export const PrivacyPolicyPage = () => {
    return (
        <div className="legal-page">
            <header className="legal-page-header">
                <a className="legal-page-brand" href="/app">
                    <span className="legal-page-brand-text">Calo</span>
                </a>
                <div className="legal-page-links">
                    <a href="/app">App Homepage</a>
                    <a href="/terms-of-use">Terms of Use</a>
                </div>
            </header>

            <main className="legal-page-main">
                <div className="legal-page-title">
                    <p className="legal-page-eyebrow">Legal</p>
                    <h1>Privacy Policy</h1>
                    <p>
                        This privacy policy applies to the Calo mobile application and its
                        related website experience on caloapp.ai.
                    </p>
                </div>
                <div className="legal-page-content">
                    <PrivacyPolicy />
                </div>
            </main>
        </div>
    );
};
